import React, {
	memo,
	useMemo
} from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'semantic-ui-react';

import styles from './table.module.css';

const PageSizeControl = ( {
	pageSize,
	setPageSize
} ) => {
	const handleChange = ( e, { value } ) => setPageSize( value );

	const options = useMemo( () => [
		{
			text: '5 rows',
			value: 5
		},
		{
			text: '10 rows',
			value: 10
		},
		{
			text: '20 rows',
			value: 20
		},
		{
			text: '25 rows',
			value: 25
		},
		{
			text: '50 rows',
			value: 50
		},
		{
			text: '100 rows',
			value: 100
		}
	], [] );

	return (
		<div className={ styles.pageSizeControl }>
			<Dropdown
				defaultValue={ pageSize }
				inline
				onChange={ handleChange }
				options={ options }
			/>
		</div>
	);
};

PageSizeControl.propTypes = {
	pageSize: PropTypes.number.isRequired,
	setPageSize: PropTypes.func.isRequired
};

export default memo( PageSizeControl );
